import "./App.css";
import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import { Fragment } from "react";
import UserAccountPage from "./user page/UserAccountPage";
import Login from "./pages/Login/login";
import secureLocalStorage from "react-secure-storage";
import UserManagement from "./User Management/UserManagement";
import InternetConnectionMonitor from "./pages/Internet Connection/InternetConnection";
import { useLocation } from "react-router-dom";
import ResetPassword from "./pages/Login/ResetPassword";
import ResetMyPassword from "./user page/ResetPassword";
import NotFound from "./pages/Not Found/NotFound";
import Loader from "./Loader/Loader";
import { Toaster } from "react-hot-toast";
import { HelmetProvider } from "react-helmet-async";
import InstallBanner from "./InstallBanner/InstallBanner";
import { fetchSignedInUser } from "./Api/index";
function App() {
  const initialState = JSON.parse(secureLocalStorage.getItem("profile"));
  const [user, setUser] = React.useState(initialState);

  const location = useLocation();
  React.useEffect(() => {
    const storedUser = JSON.parse(secureLocalStorage.getItem("profile"));
    setUser(storedUser);
  }, [location]);

  // Signed in to another app already? Pick that login up instead of showing
  // the login form.
  const [checkingLogin, setCheckingLogin] = React.useState(!initialState);
  React.useEffect(() => {
    if (initialState) return;
    fetchSignedInUser()
      .then(({ data }) => {
        secureLocalStorage.setItem("profile", JSON.stringify(data));
        setUser(data);
      })
      .catch(() => {})
      .finally(() => setCheckingLogin(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        {checkingLogin ? (
          <Loader />
        ) : (
          <Fragment>
            <InstallBanner />
            <Outlet />
            <InternetConnectionMonitor />
            <Routes>
              <Route path="/" element={user ? <UserManagement /> : <Login />} />
              <Route index element={user ? <UserManagement /> : <Login />} />

              <Route path="/login" element={<Login />} />
              <Route
                path="/settings"
                element={user ? <UserAccountPage /> : <Login />}
              />
              <Route path="/resetPassword" element={<ResetPassword />} />
              <Route
                path="/resetMyPassword/:token"
                element={<ResetMyPassword />}
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Fragment>
        )}
        <Toaster
          position="top-center"
          gutter={12}
          containerStyle={{ margin: "8px" }}
          toastOptions={{
            success: {
              duration: 3000,
            },
            error: {
              duration: 6000,
            },
            style: {
              fontSize: "14px",
              maxWidth: "500px",
              padding: "12px 16px",
              backgroundColor: "#ffffff",
              color: "#13233a",
              border: "1px solid #dfe4ea",
            },
          }}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
